import React, { useCallback } from "react";

import { useWatch } from "antd/es/form/Form";
import useFormInstance from "antd/es/form/hooks/useFormInstance";

import Cadenced from "@mapmycustomers/shared/types/base/Cadenced";

import CommonFieldName from "@app/util/fieldModel/CommonFieldName";

import FrequencySelector from "../FrequencySelector";

interface FrequencyIntervalFormEditorProps {
  disabled?: boolean;
  onChange?: (value?: Cadenced["cadenceInterval"]) => void;
  value?: Cadenced["cadenceInterval"];
}

const FrequencyIntervalFormEditor = ({
  disabled,
  onChange,
  value,
}: FrequencyIntervalFormEditorProps) => {
  const form = useFormInstance();
  const crmActivityTypeIds = useWatch(CommonFieldName.CRM_ACTIVITY_TYPE_ID, form);

  const handleChange = useCallback(
    (value: Partial<Cadenced>) => {
      form.setFields([
        {
          name: CommonFieldName.CRM_ACTIVITY_TYPE_ID,
          touched: true,
          value: value.crmActivityTypeId ?? null,
        },
      ]);
      onChange?.(value.cadenceInterval ?? null);
    },
    [form, onChange]
  );

  return (
    <FrequencySelector
      crmActivityTypeIds={crmActivityTypeIds}
      disabled={disabled}
      frequencyIntervalValue={value}
      onChange={handleChange}
    />
  );
};

export default FrequencyIntervalFormEditor;
